import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

window.addEventListener('DOMContentLoaded', () => {
	// Get all elements that calls Tippy
	const elements = document.querySelectorAll('[data-tippy-content]');

	// Initialise tippy to use these elements
	if (elements.length > 0) {
		tippy(elements, {
			theme: 'ghn',
		});
	}
});
